import { IAccountsStore } from "./types";
import { Action } from "./actions";
import * as types from "./actions.types";

const initialState: IAccountsStore = {
  accounts: [],
  isLoading: false,
};

const accountsReducer = (
  state: IAccountsStore = initialState,
  action: Action
): IAccountsStore => {
  switch (action.type) {
    case types.SET_ACCOUNTS:
      return {
        ...state,
        accounts: [...action.accounts],
        isLoading: action.isLoading,
      };
    case types.SET_IS_LOADING_ACCOUNTS:
      return {
        ...action.isLoading,
      };
    default:
      return state;
  }
};

export default accountsReducer;
